module.exports = __webpack_public_path__ + "img/tbi-zebra.4b2bbadc.png";